








































import { Component, Vue, Ref } from "vue-property-decorator";

import BaseDialogComponent from "@/components/common/BaseDialog.vue";
import NumberPickerComponent from "@/components/common/NumberPickerComponent.vue";
import PickerDialogComponent from "../common/PickerDialog.vue";
import { viewAdditionalPauseDurationOptionsClientAccess } from "@/permissions/ClientPermissions";

export interface TestRelaysData {
  numCycles: number;
  onOffDuration: number;
  relay1Active: boolean;
  relay2Active: boolean;
}

@Component({
  components: {
    "number-picker": NumberPickerComponent,
    "base-dialog": BaseDialogComponent,
    picker: PickerDialogComponent,
  },
})
export default class TestRelaysComponent extends Vue {
  numCycles = 0;
  onOffDuration = 0;
  relay1Active = true;
  relay2Active = true;

  minValue = 0;
  maxValue = 255;

  yesNoValues = [true, false];
  formatYesNo(value: boolean) {
    return this.$t(`common.${value ? "yes" : "no"}`).toString();
  }

  pauseDurationInMin = 30;
  pauseDurationInMinOptions = viewAdditionalPauseDurationOptionsClientAccess()
    ? [30, 60, 90, 120, 240]
    : [30, 60, 90];

  resolve?: (value: TestRelaysData) => void = undefined;
  reject?: (reason: string) => void = undefined;

  get pauseDurationInMinFormatter() {
    return (pauseDurationInMin: number) => {
      return pauseDurationInMin.toString();
    };
  }

  @Ref("baseDialog")
  baseDialogComponent!: BaseDialogComponent;

  async show(serialNumber: string) {
    this.baseDialogComponent.show({
      title: this.$t("comBoxDetail.testRelays.title", [
        serialNumber,
      ]).toString(),
      styleAsAlertDialog: true,
      positiveButtonText: this.$t("common.save").toString(),
      persistent: true,
    });

    this.numCycles = 0;
    this.onOffDuration = 0;
    this.relay1Active = true;
    this.relay2Active = true;

    return new Promise<TestRelaysData>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  async onSave() {
    this.resolve &&
      this.resolve({
        numCycles: Math.min(255, Math.max(this.numCycles, 0)),
        onOffDuration: Math.min(255, Math.max(this.onOffDuration, 0)),

        relay1Active: this.relay1Active,
        relay2Active: this.relay2Active,
      });
  }
}
